const committeeRecord = r => require.ensure([], () => r(require('@/page/committeeRecord/committeeRecord')), 'committeeRecord');
const businessNew = r => require.ensure([], () => r(require('@/page/committeeRecord/businessNew/businessNew')), 'businessNew');
const businessAccept = r => require.ensure([], () => r(require('@/page/committeeRecord/businessAccept/businessAccept')), 'businessAccept');
const businessComplete = r => require.ensure([], () => r(require('@/page/committeeRecord/businessComplete/businessComplete')), 'businessComplete');
const businessExamine = r => require.ensure([], () => r(require('@/page/committeeRecord/businessExamine/businessExamine')), 'businessExamine');
const committeeDetail = r => require.ensure([], () => r(require('@/page/committeeRecord/committeeDetail/committeeDetail')), 'committeeDetail');
// const realtyMgeComBaseRecord = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/realtyMgeComBaseRecord/realtyMgeComBaseRecord')), 'propertyEnterpriseRegistration');
const realtyMgeComBaseRecordAccept = r => require.ensure([], () => r(require('@/page/propertyEnterpriseRegistration/realtyMgeComBaseRecordAccept/realtyMgeComBaseRecordAccept')), 'propertyEnterpriseRegistration');
const uireview = r => require.ensure([], () => r(require('@/page/propertyMge/undertakeInspection/review/review')), 'review');
const pareview = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/review/review')), 'review');
const pcreview = r => require.ensure([], () => r(require('@/page/propertyMge/propertyContract/review/review')), 'review');
const industryCommitteeRecordReview = r => require.ensure([], () => r(require('@/page/institutionalFilingBusiness/industryCommitteeRecord/review/industryCommitteeRecordReview')), 'industryCommitteeRecordReview');
const businessDocSearch = r => require.ensure([], () => r(require('@/page/businessDocSearch/businessDocSearch')), 'businessDocSearch');
const BuildUnitInfo = r => require.ensure([], () => r(require('@/page/BuildUnits/BuildUnitInfo')), 'BuildUnitInfo');
const BuildUnitAccept = r => require.ensure([], () => r(require('@/page/BuildUnits/BuildUnitAccept')), 'BuildUnitAccept');
const BuildUnitCensor = r => require.ensure([], () => r(require('@/page/BuildUnits/BuildUnitCensor')), 'BuildUnitCensor');
const ConstructionInfo = r => require.ensure([], () => r(require('@/page/Constructions/ConstructionInfo')), 'BuildUnitInfo');
const ConstructionCensor = r => require.ensure([], () => r(require('@/page/Constructions/ConstructionCensor')), 'ConstructionCensor');
const ConstructionAccept = r => require.ensure([], () => r(require('@/page/Constructions/ConstructionAccept')), 'ConstructionAccept');
const committeeRegCensor = r => require.ensure([], () => r(require('@/page/committeeReg/committeeRegCensor')), 'committeeRegCensor');
const committeeAccept = r => require.ensure([], () => r(require('@/page/committeeReg/committeeAccept')), 'committeeAccept');
const committeeRegDetail = r => require.ensure([], () => r(require('@/page/committeeReg/committeeRegDetail')), 'committeeRegDetail');
const RealtyMgeInfo = r => require.ensure([], () => r(require('@/page/RealtyMges/RealtyMgeInfo')), 'RealtyMgeInfo');
const RealtyMgeCensor = r => require.ensure([], () => r(require('@/page/RealtyMges/RealtyMgeCensor')), 'RealtyMgeCensor');
const RealtyMgeAccept = r => require.ensure([], () => r(require('@/page/RealtyMges/RealtyMgeAccept')), 'RealtyMgeAccept');
const ownerHeaderRegCensor = r => require.ensure([], () => r(require('@/page/ownerHeaderReg/ownerHeaderRegCensor')), 'ownerHeaderRegCensor');
const ownerHeaderRegAccept = r => require.ensure([], () => r(require('@/page/ownerHeaderReg/ownerHeaderRegAccept')), 'ownerHeaderRegAccept');
const ownerHeaderRegDetail = r => require.ensure([], () => r(require('@/page/ownerHeaderReg/ownerHeaderRegDetail')), 'ownerHeaderRegDetail');
const examineRegCensor = r => require.ensure([], () => r(require('@/page/examineReg/examineRegCensor')), 'examineRegCensor');
const examineRegAccept = r => require.ensure([], () => r(require('@/page/examineReg/examineRegAccept')), 'examineRegAccept');
const examineRegDetail = r => require.ensure([], () => r(require('@/page/examineReg/examineRegDetail')), 'examineRegDetail');
export const committeeRecordRouter = {
    path: '',
    name: '业务单审批',
    component: committeeRecord,
    meta: {
        icon: 'committeeRecord',
        right: [],
        isShowMenu: true,
    },
    children: [{
            path: '/businessNew',
            component: businessNew,
            name: '新业务',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/businessAccept',
            component: businessAccept,
            name: '受理中',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/businessExamine',
            component: businessExamine,
            name: '审批中',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive:true,
            },
        },
        {
            path: '/businessComplete',
            component: businessComplete,
            name: '业主委员会备案审批',
            meta: {
                right: [],
                isShowMenu: true
            },
        },
        {
            path: '/committeeDetail',
            component: committeeDetail,
            name: '详情',
            meta: {
                right: []
            },
        },
        // {
        //     path: '/realtyMgeComBaseRecord',
        //     component: realtyMgeComBaseRecord,
        //     name: '物业企业备案',
        //     meta: {
        //         right: [],
        //         isShowMenu: true,
        //         workTemplateName: '物业企业备案',
        //         workflow: true
        //     },
        // },
        {
            path: '/uireview',
            component: uireview,
            name: '承接查验审批',
            meta: {
                right: [],
                isShowMenu: true
            }
        },
        {
            path: '/pareview',
            component: pareview,
            name: '物业区域备案审批',
            meta: {
                right: [],
                isShowMenu: true
            }
        },
        {
            path: '/pcreview',
            component: pcreview,
            name: '物业合同审批',
            meta: {
                right: [],
                isShowMenu: true
            }
        },
        {
            path: '/realtyMgeComBaseRecordAccept',
            component: realtyMgeComBaseRecordAccept,
            name: '物业企业备案受理',
            meta: {
                right: [],
                isShowMenu: false
            },
        },
        {
            path: '/industryCommitteeRecordReview',
            component: industryCommitteeRecordReview,
            name: '业主委员会备案审核',
            meta: {
                right: [],
                isShowMenu: true
            },
        },
        {
            path: '/businessDocSearch',
            component: businessDocSearch,
            name: '业务单查询',
            meta: {
                name: '业务单查询',
                right: ['业务单查询'],
                isShowMenu: true,
                keepAlive: false,
            },
        },
        {
            path:'/BuildUnitInfo',
            component: BuildUnitInfo,
            name: '建设单位注册信息',
            meta: {
              name: '建设单位注册信息详情',
              right: ['建设单位注册信息详情'],
              isShowMenu: true
            },
        },
        {
            path:'/buildUnitRegCensor',
            component: BuildUnitCensor,
            name: '建设单位注册用户审核',
            meta: {
              name: '建设单位注册用户审核',
              right: ['建设单位注册用户审核'],
              isShowMenu: true
            },
        },
        {
            path:'/buildUnitRegAccept',
            component: BuildUnitAccept ,
            name: '建设单位注册用户受理',
            meta: {
              name: '建设单位注册用户受理',
              right: ['建设单位注册用户受理'],
              isShowMenu: true
            },
        },
        {
            path:'/ConstructionInfo',
            component:ConstructionInfo,
            name: '施工单位注册信息',
            meta: {
              name: '施工单位注册信息详情',
              right: ['施工单位注册信息详情'],
              isShowMenu: true
            },
        },
        {
            path:'/constructRegCensor',
            component:ConstructionCensor,
            name: '施工单位注册用户审核',
            meta: {
              name: '施工单位注册用户审核',
              right: ['施工单位注册用户审核'],
              isShowMenu: true
            },
        },
        {
            path:'/constructRegAccept',
            component:ConstructionAccept,
            name: '施工单位注册用户受理',
            meta: {
              name: '施工单位注册用户受理',
              right: ['施工单位注册用户受理'],
              isShowMenu: true
            },
        },
        {
            path:'/RealtyMgeInfo',
            component:RealtyMgeInfo,
            name: '物业服务企业注册详情',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/propertyRegCensor',
            component:RealtyMgeCensor,
            name: '物业服务企业注册审核',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/examineRegCensor',
            component: examineRegCensor,
            name: '审价注册用户审核',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/examineRegAccept',
            component: examineRegAccept,
            name: '审价注册用户受理',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/examineRegDetail',
            component: examineRegDetail,
            name: '审价注册详情',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/ownerHeaderRegCensor',
            component: ownerHeaderRegCensor,
            name: '业主代表注册用户审核',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/ownerHeaderRegAccept',
            component: ownerHeaderRegAccept,
            name: '业主代表注册用户受理',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/ownerHeaderRegDetail',
            component: ownerHeaderRegDetail,
            name: '业主代表注册详情',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/committeeRegCensor',
            component: committeeRegCensor,
            name: '业委会注册用户审核',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/committeeAccept',
            component: committeeAccept,
            name: '业委会注册用户受理',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/committeeRegDetail',
            component: committeeRegDetail,
            name: '业委会注册详情',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
        {
            path:'/propertyRegAccept',
            component:RealtyMgeAccept,
            name: '物业服务企业注册受理',
            meta: {
              name: '物业服务企业注册',
              right: ['物业服务企业注册'],
              isShowMenu: true
            },
        },
    ]
};
export default committeeRecordRouter;
